import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCartPlus, faPlus } from "@fortawesome/free-solid-svg-icons";
import Product from "./Product";
import { useLocation } from "react-router-dom";
import { useInvoiceContext } from "../context";
import { API_BASE_URL } from "../config";

const ModalAddItemToCart = (props) => {
  const location = useLocation();
  const queryString = new URLSearchParams(location.search);
  const cartquery64 = queryString.get("cart");
  const cartquery = atob(cartquery64);
  const paymentType =
    cartquery.split(":")[1] !== undefined ? cartquery.split(":")[1] : "c";

  const [products, setProducts] = useState([]);
  const { cart, addItemInCart } = useInvoiceContext();

  const addProduct = (product) => {
    addItemInCart(product);
    props.onHide();
  };

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetch(
          `${API_BASE_URL}/getproducts/${paymentType}`,
        );
        const jsonData = await response.json();

        const products = jsonData.itens;
        setProducts(products);
      } catch (error) {}
    };

    fetchProducts();
  }, [paymentType]);

  return (
    <Modal {...props} size="md" centered>
      <Modal.Header closeButton>
        <FontAwesomeIcon
          icon={faCartPlus}
          style={{ color: "#333", fontSize: "1.5rem" }}
          className="me-2"
        />
        Adicionar um item ao carrinho:
      </Modal.Header>
      <Modal.Body
        style={{
          maxHeight: "calc(100vh - 410px)",
          overflowY: "auto",
        }}
      >
        {products.length === 0 ? (
          <div className="d-flex justify-content-center">
            <div className="spinner-border text-success" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          <div className="justify-content-center">
            {products.map((product, index) => {
              if (cart.some((item) => item.id === product.id)) {
                return null; // retornando null quando o produto está no carrinho
              }

              return (
                <Product
                  key={index}
                  index={index}
                  name={product.name}
                  desc={product.desc}
                  price={parseFloat(product.price)}
                  fullPrice={parseFloat(product.full_price)}
                  actionText="adicionar"
                  actionHoverColor="#69B190"
                  actionIcon={faPlus}
                  actionOnClick={() => {
                    addProduct(product);
                  }}
                  hasInfo={product.tem_info}
                  info={product.info}
                />
              );
            })}
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ModalAddItemToCart;
